var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_layout"},[_c('Header'),_c('div',{class:_vm.isCollapse ? 'body2': 'body'},[_c('sider-menu'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }